export default __webpack_public_path__ + "static/media/right.96dbc4c2.svg";